import BrandLogo from '../Brand/BrandLogo';
import React, { useEffect, useState, useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import {
  Compass,
  ChartNoAxesCombined,
  Music2,
  ChartPie,
  Wallet,
  Search as SearchIcon,
  Bell,
  Menu,
  X,
  UserRound,
  ArrowUpRight,
  ChevronRight,
} from 'lucide-react';
import './Header.scss';
import '../../styles/DarkMarketplace.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  bookmarkStart,
  userDetailsStart,
  logout,
} from '../../redux/user/Action';
import { useHistory, useLocation } from 'react-router';
import Notification from '../Notification/Notification';
import debounce from 'lodash.debounce';
import NoticeBar from '../NoticeBar/NoticeBar';
import { NoticePopup } from '../NoticePopup/NoticePopup';
const navigation = [
  ['Discover', '/home', Compass],
  ['Marketplace', '/trade', ChartNoAxesCombined],
  ['My music', '/music', Music2],
  ['Portfolio', '/portfolio', ChartPie],
  ['Wallet', '/wallet', Wallet],
];

const Header = ({ ual }) => {
  const dispatch = useDispatch();
  const userdetails = useSelector((state) => state.user.data);
  const history = useHistory();
  const [expanded, setExpanded] = useState(false);
  const [notify, setNotify] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);
  useEffect(() => {
    if (!expanded) return;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setExpanded(false);
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [expanded]);

  const [showNotice, setShowNotice] = useState(false);

  const handleOkNotice = () => {
    setShowNotice(false);
    localStorage.setItem('generalnoticeviewed', true);
  };
  const handleCancelNotice = () => {
    localStorage.setItem('generalnoticeviewed', true);
    setShowNotice(false);
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(userDetailsStart({}));
      dispatch(bookmarkStart({}));
    }
  }, [dispatch]);

  const handlePage = (name) => {
    setExpanded(false);
    history.push(`/${name}`);
  };

  useEffect(() => {
    if (
      userdetails &&
      userdetails?._id &&
      !userdetails?.is_anchor_enabled &&
      !userdetails?.isOauth
    ) {
      let isanchorEnabled =
        userdetails?.is_anchor_enabled || userdetails?.isOauth;
      const passwordCh = userdetails?.password_changed;
      if (passwordCh) {
        let today = Date.now();
        let changeDate = new Date(userdetails?.change_passsword_after);

        if (changeDate < today) {
          if (!localStorage.getItem('generalnoticeviewed')) {
            !isanchorEnabled && setShowNotice(true);
          }
          return;
        }
      }
      if (passwordCh === false) {
        // changes
        if (!localStorage.getItem('generalnoticeviewed')) {
          !isanchorEnabled && setShowNotice(true);
        }

        return;
      }
    }
  }, [userdetails]);

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        history.push(`/home/campaigns?name=${encodeURIComponent(value)}`);
      }, 300),
    [history]
  );
  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  const debouncedChangeHandler = (e) => debouncedSearch(e.target.value);
  return (
    <>
      <NoticeBar
        isVisible={userdetails?.private_key_exported === false}
        message={
          'Please export your private key before 28th of May. After this you will not be able to get your private key.'
        }
      />
      <NoticePopup
        show={showNotice}
        setShow={setShowNotice}
        message={'Please change your password as it is more than 6 months old'}
        handleClose={handleCancelNotice}
        handleOk={handleOkNotice}
      />
      <header
        className={`tm-market-header ${
          location.pathname === '/home' ||
          location.pathname.startsWith('/music') ||
          location.pathname.startsWith('/portfolio') ||
          location.pathname.startsWith('/wallet') ||
          location.pathname.startsWith('/trade') ||
          location.pathname.startsWith('/mycrowdsale') ||
          location.pathname.startsWith('/profile') ||
          location.pathname.startsWith('/security') ||
          location.pathname.startsWith('/devices')
            ? 'tm-dark-header'
            : ''
        }`}
      >
        <div className="tm-header-inner">
          <BrandLogo />
          <nav className="tm-primary-nav" aria-label="Main navigation">
            {navigation.map(([label, path, Icon]) => (
              <RouterNavLink
                key={path}
                exact={path === '/home'}
                to={path}
                activeClassName="is-active"
              >
                <Icon size={16} aria-hidden="true" />
                {label}
              </RouterNavLink>
            ))}
          </nav>
          <form
            className="tm-header-search"
            role="search"
            onSubmit={(event) => {
              event.preventDefault();
              debouncedSearch.flush();
            }}
          >
            <SearchIcon size={16} aria-hidden="true" />
            <label className="sr-only" htmlFor="tm-market-search">
              Search music campaigns
            </label>
            <input
              id="tm-market-search"
              type="search"
              placeholder="Search music"
              onChange={debouncedChangeHandler}
            />
          </form>
          <div className="tm-header-actions">
            <a
              className="tm-header-nft"
              href="https://nft.zeptagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              NFT <ArrowUpRight size={12} aria-hidden="true" />
            </a>
            {localStorage.getItem('token') && (
              <button
                className="tm-header-icon"
                aria-label="Notifications"
                onClick={() => setNotify(true)}
              >
                <Bell size={20} aria-hidden="true" />
              </button>
            )}
            {localStorage.getItem('token') ? (
              <Dropdown className="tm-profile-menu">
                <Dropdown.Toggle
                  variant="light"
                  id="tm-profile-toggle"
                  aria-label="Open account menu"
                >
                  <span className="tm-profile-avatar">
                    {userdetails?.name?.charAt(0)?.toUpperCase() || (
                      <UserRound size={18} aria-hidden="true" />
                    )}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right">
                  <Dropdown.Header>
                    {userdetails?.name || 'Your account'}
                  </Dropdown.Header>
                  <Dropdown.Item onClick={() => handlePage('profile')}>
                    Account info
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handlePage('mycrowdsale')}>
                    My crowdsales
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handlePage('security')}>
                    Security
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => handlePage('guide')}>
                    Guide
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handlePage('support')}>
                    Support
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => dispatch(logout({ ual }))}>
                    Log out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Link className="tm-header-connect" to="/login">
                Connect wallet
              </Link>
            )}
            <button
              className="tm-header-icon tm-menu-toggle"
              aria-label={expanded ? 'Close navigation' : 'Open navigation'}
              aria-expanded={expanded}
              aria-controls="tm-mobile-navigation"
              onClick={() => setExpanded((previous) => !previous)}
            >
              {expanded ? <X size={21} /> : <Menu size={21} />}
            </button>
          </div>
        </div>
        {expanded && (
          <nav
            id="tm-mobile-navigation"
            className="tm-mobile-navigation"
            aria-label="Mobile navigation"
          >
            <form
              className="tm-mobile-search"
              role="search"
              onSubmit={(event) => {
                event.preventDefault();
                debouncedSearch.flush();
                setExpanded(false);
              }}
            >
              <SearchIcon size={18} aria-hidden="true" />
              <label className="sr-only" htmlFor="tm-mobile-search-input">
                Search music campaigns
              </label>
              <input
                id="tm-mobile-search-input"
                type="search"
                placeholder="Search music campaigns"
                onChange={debouncedChangeHandler}
              />
            </form>
            {navigation.map(([label, path, Icon]) => (
              <RouterNavLink
                key={path}
                exact={path === '/home'}
                to={path}
                activeClassName="is-active"
                onClick={() => setExpanded(false)}
              >
                <Icon size={18} aria-hidden="true" />
                {label}
                <ChevronRight size={16} aria-hidden="true" />
              </RouterNavLink>
            ))}
            <div className="tm-mobile-secondary">
              <a
                href="https://nft.zeptagram.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                NFT marketplace
              </a>
              {[
                ['My crowdsales', 'mycrowdsale'],
                ['Security', 'security'],
                ['Guide', 'guide'],
                ['Support', 'support'],
              ].map(([label, path]) => (
                <Link
                  key={path}
                  to={'/' + path}
                  onClick={() => setExpanded(false)}
                >
                  {label}
                </Link>
              ))}
            </div>
          </nav>
        )}
      </header>
      {notify && <Notification show={notify} setShow={setNotify} />}
    </>
  );
};

export default Header;
